import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Text,
  Title,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { ACCOUNTS_CLIPBOARD_RESUME_FULL_PATH } from "@src/appV2/Accounts/ClipboardResume/paths";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { RESUME_DOCUMENT_REQUIREMENT_FULL_PATH } from "../../Documents/paths";
import { useGetPlacementCandidate } from "../../PlacementCandidate/api/useGetPlacementCandidate";
import { useIsJobsEnabled } from "../../PlacementCandidate/useIsJobsEnabled";
import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageJobsProfileSection() {
  const history = useHistory();
  const worker = useDefinedWorker();

  const isJobsEnabled = useIsJobsEnabled();
  const isPassportEnabled = useCbhFlag(CbhFeatureFlag.PLACEMENT_CANDIDATE_RESUME_PARSING, {
    defaultValue: false,
  });
  const mayShowPassportMenuItem = isJobsEnabled && isPassportEnabled;
  const { data: placementCandidate } = useGetPlacementCandidate(
    { workerId: worker.userId },
    { enabled: mayShowPassportMenuItem }
  );

  return (
    <>
      <Title semibold component="h4">
        Jobs Profile
      </Title>
      <ListItem>
        <ListItemButton
          onClick={() => {
            logAccountPageMenuItemTapped("Upload Resume");
            history.push(RESUME_DOCUMENT_REQUIREMENT_FULL_PATH);
          }}
        >
          <ListItemIcon iconType="resume" />
          <ListItemText
            primary="Resume"
            secondary={
              <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
                Create or upload a resume to apply to jobs
              </Text>
            }
          />
        </ListItemButton>
      </ListItem>
      {isDefined(placementCandidate?.passportUrl) && (
        <>
          <Divider />
          <ListItem>
            <ListItemButton
              onClick={() => {
                logAccountPageMenuItemTapped("Clipboard Resume");
                history.push(`${ACCOUNTS_CLIPBOARD_RESUME_FULL_PATH}`);
              }}
            >
              <ListItemIcon iconType="document-id-outlined" />
              <ListItemText primary="Get your Clipboard passport" />
            </ListItemButton>
          </ListItem>
        </>
      )}
    </>
  );
}
